module.exports = __webpack_public_path__ + "1792395595471/images/spec-bg.29bc326.png";